module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// (webpack)/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 399
// module chunks = 0